import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  DEVICE_APPLICATION_STATE_FEATURE_KEY,
  DeviceApplicationStateStoreState,
} from './device-application-state.state';

export const selectDeviceApplicationStateFeature = createFeatureSelector<DeviceApplicationStateStoreState>(
  DEVICE_APPLICATION_STATE_FEATURE_KEY
);

export const selectDeviceApplicationStateLoaded = createSelector(selectDeviceApplicationStateFeature, (s) => s.loaded);

export const selectDeviceApplicationStateEntities = createSelector(
  selectDeviceApplicationStateFeature,
  (s) => s.entities
);

export const selectDeviceApplicationIsInUseByUdid = (udid: string) =>
  createSelector(selectDeviceApplicationStateEntities, (entities) => entities[udid]?.inUse ?? false);
